function GetQueryString(name)
{
    let reg = new RegExp("(^|&)"+name+"=([^&*])(&|$)")
    let r = window.location.search.substr(1).match(reg)
    if(r!=null) return unescape(r[2]);
    return 0;
}
let type = GetQueryString('type');
let arr = [
    {
        path: '/static/setting/language-switch',
        component: () => import('views/modules/setting/language-switch/index'),
        meta: {
            title: '423452',
        },
    },
    {
        path: '/static/clues/detail',
        name: 'clues-detail',
        component: () => import('views/modules/np/form/app/detail'),
        meta: {
            parent: '/clues',
            icon: 'el-icon-document',
            title: '线索详情',
            path: '',
            isApp: false,
            isIframe: false,
            isLink: false,
            isAffix: false,
            isHide: false,
            params: {},
        },
    },
    {
        path: '/static/membercompany/:appId',
        component: () => import('views/modules/member/membercompany'),
        meta: {
            parent: '/member',
            title: '企业列表',
        },
    }, {
        path: '/static/member/:appId',
        component: () => import('views/modules/member/memberlist'),
        meta: {
            parent: '/member',
            title: '会员列表',
        },
    },
    {
        path: '/static/membercompany/detail/:appId/:bizId',
        name:'memdetail',
        component: () => import('views/modules/member/membercompany/detail'),
        meta: {  
            parent:`/member/${type=='1'?'membercompany':'memberlist'}`,          
            title: '详情',
        },
    },
    {
        path: '/static/membercard',
        name:'membercard',
        component: () => import('views/modules/member/membercard/index'),
        meta: {  
            parent:`/member/${type=='1'?'membercompany':'memberlist'}`,          
            title: '会员卡',
        },
    },{
        path: '/static/customer/:appId',
        name:'customer',
        component: () => import('views/modules/member/customer/index'),
        meta: {  
            parent:`/member/${type=='1'?'membercompany':'memberlist'}`,          
            title: '客户管理',
        },
    },{
        path: '/static/clues/:appId',
        name:'clue',
        component: () => import('views/modules/member/clues/index'),
        meta: {  
            parent:`/member/clue`,          
            title: '客户管理',
        },
    },{
        path: '/static/clues/detail/:appId',
        name:'clue',
        component: () => import('views/modules/member/clues/detail'),
        meta: {  
            parent:`/member/clue`,          
            title: '客户管理',
        },
    }, {
        path: '/static/customer/set/:appId',
        name: 'clue',
        component: () => import('views/modules/member/customerset/index'),
        meta: {
            parent: `/member/clue`,
            title: '客户管理',
        },
    },  {
        path: '/static/memberset/:appId',
        name: 'clue',
        component: () => import('views/modules/member/memberset/index'),
        meta: {
            parent: `/member/clue`,
            title: '客户设置管理',
        },
    },
];
export default arr;
